<ng-container *ngIf="allOptions?.length">
	<div [ngClass]="styles.gridContainer" cdkDropList (cdkDropListDropped)="drop($event)">

		<div [ngClass]="styles.gridRow" *ngFor="let option of allOptions; let index=index" layout="row" flex-wrap="false" cdkDrag>
			<div>
				<vb-ui-checkbox [name]="'isSelected' + index" [(ngModel)]="option.$isSelected" (ngModelChange)="selectOption(option, option.$isSelected)" [disabled]="isForceSelected(option)" [accessibilityLabel]="getName(option)">
				</vb-ui-checkbox>
			</div>

			<div layout="column" [ngClass]="styles.fillColumn">

				<div>
					{{ getName(option) }}
				</div>

				<div [ngClass]="styles.subText">
					{{ getSubheading(option) }}
				</div>
			</div>
			<div>
				<span class="glyphicons show_lines"></span>
			</div>
		</div>
	</div>
</ng-container>
